export const referenceDataTypes = {
  rate: 'rate',
  subvention: 'subvention',
};
